<template>
  <div class="loading" v-if="display.loading">
    <div class="load">
      <hr><hr><hr><hr>
      <div class="loadback"></div>
    </div>
  </div>
  <div v-else>
    <div
      style="background-color: #f1f1f1; vertical-align: middle; display: flex; padding: 35px 25px 0px; text-align: center; margin: 0 auto; flex-direction: column; min-height: 100vh;"
      v-if="this.isDowngrade === 'yes'">
      <div>
        <div class="wedget-logo" style="margin: 0 0px 0 20px; text-align: right; position: relative; display: block;">
          <img :src="host + '/static/front/images/b1g1-light-widget.png'"
               style="width: 56px; position: absolute; right: 0px; top: -20px;">
        </div>
      </div>
      <h3 style="text-align: center;font-size: 34px;color: #000;font-weight: 400; margin-top:50px;"></h3>
      <div style="text-align: center; font-size: 22px;color: #000;">
        It seems like there is an issue with the Membership Account.
        <br>Please update the Membership record by logging into the account. <br>
      </div>
    </div>
    <div
    style="background-color: #f1f1f1; vertical-align: middle; display: flex; padding: 35px 25px 0px; text-align: center; margin: 0 auto; flex-direction: column; min-height: 100vh;"
    v-else-if="this.isStorydraft === 'yes'">
    <div>
      <div class="wedget-logo" style="margin: 0 0px 0 20px; text-align: right; position: relative; display: block;">
        <img :src="host + '/static/front/images/b1g1-light-widget.png'"
             style="width: 56px; position: absolute; right: 0px; top: -20px;">
      </div>
    </div>
    <h3 style="text-align: center;font-size: 34px;color: #000;font-weight: 400; margin-top:50px;"></h3>
    <div style="text-align: center; font-size: 22px;color: #000;">
      This Recurring Impact is in Draft mode right now.
        <br>Please active it to display the widget. <br>
    </div>
  </div>
    <div v-else-if="story">
      <StoryWidgetMobile v-if="isMobile" :story="story" :storyDescTitle="storyDescTitle"></StoryWidgetMobile>
      <StoryWidgetWeb v-else :story="story" :storyDescTitle="storyDescTitle"></StoryWidgetWeb>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
import storyAPI from '../../../api/story'
import config from '../../../config/app'
import StoryWidgetMobile from './StoryWidgetMobile'
import StoryWidgetWeb from './StoryWidgetWeb'

export default {
  data () {
    return {
      story: null,
      getCompanyName: '-',
      getCompanyId: 0,
      getUserId: 0,
      isDowngrade: 'no',
      isStorydraft: 'no',
      host: config.host,
      display: {
        loading: false
      },
      storyDescTitle: '',
      isMobile: store.getters.isMobile
    }
  },
  components: {
    StoryWidgetMobile, StoryWidgetWeb
  },
  created () {
    this.display.loading = true
    let id = this.$route.params.id.indexOf('/') > -1 ? atob(this.$route.params.id.substr(0, this.$route.params.id.indexOf('/'))) : atob(this.$route.params.id)
    let storyPromise = {}

    storyAPI.getCompnayDowngradeStatus(id, [], {status: 1}).then((statusResponse) => {
      this.isDowngrade = statusResponse.isDowngrade
      this.isStorydraft = statusResponse.isStorydraft
      if (this.isDowngrade === 'no') {
        storyPromise = storyAPI.getByIdPubic(id, ['Company', 'Project', 'Project.ImageSquare', 'Impact', 'Contributions', 'User'], {status: 1}).then((response) => {
          this.story = response
          // let userName = response.user.first_name + ' ' + response.user.last_name
          this.getUserId = response.user.id
          this.storyDescTitle = (response.company === null) ? 'I' : 'we'
          this.story.story_text = response.story_text.replace('When ', '')

          let impact = this.story.impact.impact_unit * this.story.quantity
          this.story.text1 = (parseInt(this.story.is_giving_monthly) ? '' : 'When ') + this.story.story_text
          this.story.text2 = this.storyDescTitle + ' ' + this.story.project.verb_present + ' ' + this.commafy(impact) + ' ' + (impact > 1 ? this.story.project.phrase_active_plural : this.story.project.phrase_active_singular) + '.'
          this.story.textPP = this.story.project.verb_pp
          let totalBeneficiaries = 0
          let projectId = response.project_id
          let isBundle = response.project ? parseInt(response.project.is_bundle) : 0
          if (response.contributions.length > 0) {
            response.contributions.forEach((contribution) => {
              if (isBundle) {
                totalBeneficiaries += contribution.beneficiaries
              } else if (contribution.project_id === projectId) {
                totalBeneficiaries += contribution.beneficiaries
              }
            })
          }

          this.story.text3 = totalBeneficiaries === 1 ? this.story.project.phrase_active_singular : this.story.project.phrase_active_plural
          this.story.totalBeneficiaries = this.commafy(totalBeneficiaries)
          this.story.image = this.story.project.image_square ? this.story.project.image_square.image_name : this.story.giving_story_image
        }).catch((error) => {
          console.log(error)
          this.display.loading = false
        })
      }
    }).catch((error) => {
      console.log(error)
      this.display.loading = false
    })

    Promise.all([storyPromise]).then(() => {
      this.display.loading = false
      setTimeout(function () {
        document.documentElement.style.overflow = 'hidden'
      }, 1000)
    })
  },
  methods: {
    commafy (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getBusinessProfileUrl () {
      return (this.getCompanyId !== 0) ? this.host + '/business-account-profile/' + this.getCompanyId : this.host + '/personal-account-profile/' + this.getUserId
    },
    onImageLoadFailure (event, id) {
      document.getElementById(id).src = this.defaultStoryImage
    },
    getStoryText (story) {
      let text = ''
      let impact = story.impact.impact_unit * story.quantity
      text = (parseInt(story.is_giving_monthly) ? '' : 'When ') + story.story_text + ', ' + this.storyDescTitle + ' ' + story.project.verb_present + ' ' + impact + ' '
      if (impact > 1) {
        text += story.project.phrase_active_plural + '.'
      } else {
        text += story.project.phrase_active_singular + '.'
      }
      return text
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/StoryWidget/StoryWidget.vue